<template>
  <div>
    <el-table
      height="calc(100vh - 360px)"
      class="coin-table"
      :data="currencyList"
      :row-key="() => Math.random()"
    >
      <el-table-column label="币种" width="120" fixed prop="code">
        <template slot-scope="scope">
          <div class="logo">
            <img :src="scope.row.logo" />
            {{ scope.row.code }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="chain" width="120" fixed prop="chain">
        <template slot-scope="scope">
          {{ scope.row.chain }}
        </template>
      </el-table-column>
      <el-table-column label="地址源" width="120" fixed prop="addressSource">
        <template slot-scope="scope">
          {{ scope.row.addressSource ? scope.row.addressSource : '--' }}
        </template>
      </el-table-column>
      <el-table-column label="充值">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            @change="handleStatusChange(scope.row, 'deposit', $event)"
            :value="scope.row.supportDeposit"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="提现">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            @change="handleStatusChange(scope.row, 'withdraw', $event)"
            :value="scope.row.supportWithdraw"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="交易">
        <template slot-scope="scope">
          <el-switch
            :disabled="1"
            active-color="#13ce66"
            @change="handleTradeStatusChange(scope.row, $event)"
            :value="scope.row.supportTrade"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="展示">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            @change="handleDisplayChange(scope.row, $event)"
            :value="scope.row.shouldDisplay"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column label="设为主区">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            @change="hadnleAreaTypeChange(scope.row, $event)"
            :value="!scope.row.areaType"
          >
          </el-switch>
        </template>
      </el-table-column>
      <!-- <el-table-column label="红包">
        <template slot-scope="scope">
          <el-switch
            active-color="#13ce66"
            @change="handleRedPacketChange(scope.row, $event)"
            :value="scope.row.supportRedPacket"
          >
          </el-switch>
        </template>
      </el-table-column> -->
      <el-table-column prop="minimumDepositAmount" label="最小交易额">
      </el-table-column>
      <el-table-column prop="withdrawFee" label="提现手续费"> </el-table-column>
      <el-table-column prop="displayPrecision" label="显示精度">
      </el-table-column>
      <el-table-column prop="actualPrecision" label="实际精度">
      </el-table-column>
      <el-table-column label="单笔提现额度">
        <template slot-scope="scope">
          {{ scope.row.minWithdrawSingle }} ~ {{ scope.row.maxWithdrawSingle }}
        </template>
      </el-table-column>
      <el-table-column prop="maxWithdrawOneDay" label="当日提现额度">
      </el-table-column>
      <el-table-column label="操作" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            icon="el-icon-edit"
            circle
            size="small"
            @click="handleEdit(scope.row)"
          ></el-button>
          <el-button
            type="danger"
            icon="el-icon-delete"
            circle
            size="small"
            @click="handleRemove(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handlePageChanged"
    >
    </pagination>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex'
import Pagination from 'components/pagination'
import CurrencyDetail from '../detail/index.vue'
import SortableMixin from 'mixins/SortableMixin'

export default {
  name: 'CurrencyList',
  mixins: [SortableMixin],
  components: {
    Pagination,
  },
  data() {
    return {
      sortable: '.coin-table',
    }
  },

  computed: {
    ...mapGetters('currencySetting', ['currencyList']),
    ...mapState('currencySetting', ['pagination', 'totalCount']),
  },
  mounted() {
    this.getSourceAddress()
  },
  methods: {
    ...mapMutations('currencySetting', ['toggleDetailDialogVisible']),
    ...mapActions('currencySetting', [
      'list',
      'updateDepositStatus',
      'updateWithdrawStatus',
      'updateTradeStatus',
      'updateDisplayStatus',
      'updateAreaType',
      'updateSort',
      'detail',
      'remove',
      'updateRedPacketStatus',
      'getSourceAddress',
    ]),
    //排序
    // formatter(row, column) {
    //     return row.code;
    //   },
    handleStatusChange(row, type, status) {
      const message =
        type === 'deposit'
          ? `确认要${status ? '开启' : '关闭'}充值功能吗？`
          : `确认要${status ? '开启' : '关闭'}提现功能吗？`

      this.$confirm(message, '提示', { type: 'warning ' }).then(() => {
        const action =
          type === 'deposit'
            ? this.updateDepositStatus
            : this.updateWithdrawStatus

        action({ coinType: row.coin, status, chain: row.chain }).then(() => {
          this.$message.success('操作成功！')
          this.$emit('refresh')
        })
      })
    },
    handleTradeStatusChange(row, status) {
      const message = status
        ? '确认要开启交易功能吗？'
        : '确认要关闭交易功能吗？关闭该币种交易功能，相关的交易对交易功能也将关闭。'

      this.$confirm(message, '提示', { type: 'warning' }).then(() => {
        this.updateTradeStatus({
          coinType: row.coin,
          chain: row.chain,
          status,
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功！')
            this.$emit('refresh')
          }
        })
      })
    },
    handleDisplayChange(row, status) {
      this.$confirm('确认要进行此操作吗？', '提示', { type: 'warning' }).then(
        () => {
          this.updateDisplayStatus({
            coinType: row.coin,
            chain: row.chain,
            status,
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功！')
              this.$emit('refresh')
            }
          })
        }
      )
    },
    hadnleAreaTypeChange(row, status) {
      this.$confirm('确认要进行此操作吗？', '提示', { type: 'warning' }).then(
        () => {
          this.updateAreaType({
            coinType: row.coin,
            chain: row.chain,
            type: +!status,
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功！')
              this.$emit('refresh')
            }
          })
        }
      )
    },
    handleRedPacketChange(row, status) {
      this.$confirm('确认要进行此操作吗？', '提示', { type: 'warning' }).then(
        () => {
          this.updateRedPacketStatus({
            coinType: row.code,
            chain: row.chains ? row.chains[0] : '',
            status,
          }).then((res) => {
            if (res.code == 0) {
              this.$message.success('操作成功！')
              this.$emit('refresh')
            }
          })
        }
      )
    },
    async handleEdit(currency) {
      localStorage.setItem('coinType', currency.coin)
      localStorage.setItem('chain', currency.chain)
      await this.detail({
        coinType: currency.coin ? currency.coin : '',
        chain: currency.chain ? currency.chain : '',
      })
      this.toggleDetailDialogVisible(true)
    },
    handleRemove(row) {
      this.$confirm('确认要删除该币种吗？', '提示', { type: 'warning' }).then(
        () => {
          this.remove({ code: row.coin, chain: row.chain }).then(() => {
            this.$message.success('删除成功！')
            this.$emit('refresh')
          })
        }
      )
    },
    handlePageChanged(pagination) {
      this.$emit('refresh', pagination)
    },

    onSort(evt) {
      const { oldIndex, newIndex } = evt
      const { page, size } = this.pagination

      // if (oldIndex !== newIndex) {
      const coinType = this.currencyList[oldIndex].code
      const chain = this.currencyList[oldIndex].chains[0]
      this.updateSort({
        chain: chain,
        coinType: coinType,
        orderNo: (page - 1) * size + newIndex + 1,
      }).then(() => {
        this.$message.success('更新成功！')
        this.$emit('refresh')
      })
      // }
    },
  },
}
</script>

<style lang="less" scoped>
.logo {
  display: flex;
  align-items: center;

  img {
    margin-right: 8px;
    width: 44px;
    height: 44px;
    border: 0;
  }
}
</style>
